import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  unreadCount: '',
};

const organiztionSlice = createSlice({
  name: 'organiztion',
  initialState,
  reducers: {
    setUnreadCount(state, action) {
      state.unreadCount = action.payload;
    },
  },
});

export const { setUnreadCount } = organiztionSlice.actions;

const organiztionReducer = organiztionSlice.reducer;

export default organiztionReducer;
